import React, { Component } from 'react';
import Sidenavigation from '../layouts/Sidenavigation';
import Topnavigation from '../layouts/Topnavigation';
import Editcategorycontent from '../sections/Addproduct/Editcategorycontent'
import Quickbar from '../layouts/Quickbar';

class Editcategory extends Component {
    render() {
        return (
            <div className="ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar">
                <Sidenavigation />
                <main className="body-content">
                    <Topnavigation />
                    <Editcategorycontent/>
                </main>
                <Quickbar />
            </div>
        );
    }
}

export default Editcategory;